// // src/context/FeaturesContext.js
// import React, { createContext, useContext, useEffect, useState } from "react";
// import { useAuth } from "../AuthContext";

// // إنشاء السياق
// const FeaturesContext = createContext();

// // المزوّد (Provider)
// export const FeaturesProvider = ({ children }) => {
//   const { user, isAuthenticated } = useAuth();
//   const [features, setFeatures] = useState({});
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     if (isAuthenticated && user?.tenant_featuers) {
//       // نحول المصفوفة إلى كائن key/value
//       const mapped = {};
//       user.tenant_featuers.forEach((item) => {
//         mapped[item.key] = item.value === "1"; // نحولها لقيمة منطقية true/false
//       });
//       setFeatures(mapped);
//       console.log("🌟 Features Loaded:", mapped);
//     } else {
//       setFeatures({});
//     }
//     setLoading(false);
//   }, [isAuthenticated, user]);

//   // دالة التحقق السريع من الميزة
//   const hasFeature = (key) => {
//     return features && features[key] === true;
//   };

//   return (
//     <FeaturesContext.Provider value={{ features, hasFeature, loading }}>
//       {children}
//     </FeaturesContext.Provider>
//   );
// };

// // Hook مخصص للوصول السريع
// export const useFeatures = () => useContext(FeaturesContext);


// src/context/FeaturesContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "../AuthContext";

const FeaturesContext = createContext();

export const FeaturesProvider = ({ children }) => {
  const { user, isAuthenticated } = useAuth();
  const [features, setFeatures] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isAuthenticated && user?.tenant_featuers) {
      const mapped = {};

      user.tenant_featuers.forEach((item) => {
        if (item.type === "boolean") {
          // لو نوعها منطقية
          mapped[item.key] = item.value === "1";
        } else if (item.type === "numeric") {
          // لو نوعها رقمية
          mapped[item.key] = Number(item.value);
        } else {
          // أي نوع آخر نخليه كما هو
          mapped[item.key] = item.value;
        }
      });

      setFeatures(mapped);
      console.log("🌟 Features Loaded:", mapped);
    } else {
      setFeatures({});
    }
    setLoading(false);
  }, [isAuthenticated, user]);

  const hasFeature = (key) => {
    const value = features[key];
    // لو الميزة Boolean → نتحقق من تفعيلها
    if (typeof value === "boolean") return value === true;
    // لو رقمية → نتحقق إنها أكبر من الصفر (مثلاً عدد الخزن > 0)
    if (typeof value === "number") return value > 0;
    return false;
  };

  return (
    <FeaturesContext.Provider value={{ features, hasFeature, loading }}>
      {children}
    </FeaturesContext.Provider>
  );
};

export const useFeatures = () => useContext(FeaturesContext);
